<template>
  <div class="home">
    <el-tabs type="border-card">
      <el-tab-pane class="paddingBody" :label="$t('Tarea')">
        <el-row>
          <el-col :md="11">
            <el-form onsubmit="return false;" label-position="top">
              <b>
                <el-form-item label="Nombre de la tarea" :class="{ intermitente: taskName === '' ? true : false }">
                  <el-input style="width: 70%" readonly size="medium" placeholder="Nombre de la tarea"
                    v-model="taskName">
                  </el-input>
                  <el-button style="width: 30%" type="primary" size="medium" @click="openDialogTarea"
                    icon="el-icon-edit">
                    Nombrar
                  </el-button>
                  <br />
                  <span v-if="taskName === ''" class="messageTask fontRed">(*) Ingresa el nombre de la tarea para
                    continuar.</span>
                </el-form-item>
              </b>
            </el-form>
          </el-col>
          <el-col :offset="3" :md="10">
            <StepsInventario v-bind:step="0" />
          </el-col>
        </el-row>

        <h4 v-if="taskName !== ''" class="help-instructions">
          Seleccione el o los
          <b>Riesgos estandarizados</b> que se apliquen a su tarea. En caso de
          no encontrar alguno, puede ingresar un <b>Nuevo Riesgo</b> o
          <b>Aspecto Ambiental</b> a su tarea.
        </h4>

        <br />
        <el-row :gutter="20" v-if="taskName !== ''">
          <el-col :md="11">
            <h1>Riesgos estandarizados</h1>
            <br />
            <el-button icon="el-icon-plus" @click="openDialogAddHealthRisks" size="medium" class="colorSalud">Salud
            </el-button>
            <el-button icon="el-icon-plus" @click="openDialogAddSecurityRisk" size="medium" class="colorSeguridad">
              Seguridad</el-button>
            <el-button icon="el-icon-plus" @click="openDialogAddMediambienteRisks" size="medium"
              class="colorMedioambiente">
              Medioambiente
              <!-- Salud y Seguridad -->
            </el-button>
          </el-col>
          <el-col :md="10">
            <h1>Nuevo Riesgo</h1>
            <br />
            <el-button @click="openDialogAddCustomRisk" icon="el-icon-plus" size="medium" class="colorCustom">Agregar
              riesgo</el-button>
          </el-col>
        </el-row>

        <br />
        <br />

        <el-button v-if="riesgos.length > 0" @click="openCopyRiskList()" style="margin-right: 20px;"
          icon="el-icon-refresh" type="primary" size="small">Copiar los riesgos seleccionados a otra tarea</el-button>

        <span v-if="taskName !== ''">
          Cantidad de riesgos:
          <b>{{ cantidadRiesgos }}</b>
        </span>
        <el-table empty-text="Sin riesgos registrados" v-if="taskName !== ''" :max-height="700" class="tableRisks" ref="multipleTable"
          :data="$store.getters.inventario_copy.tareas[$store.getters.selectedIndexTask].riesgos" style="width: 100%"
          row-class-name="rowClassTablaPloma" :cell-class-name="pintar"
          header-cell-class-name="header-cell-class-table-gray" @selection-change="handleSelectionChangeTareas">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column type="expand" width="40" label="+" align="center" :key="componentKey">
            <template slot-scope="scope">
              <div style="padding-left: 30px; padding-right: 30px; padding-bottom: 20px;
                ">
                <el-row>
                  <el-col :span="8">
                    <h4>Causas</h4>
                    <ol>
                      <li v-for="(item, index) in scope.row.causas" :key="index">
                        {{ item.nombre }}
                      </li>
                    </ol>
                  </el-col>
                  <el-col :span="8">
                    <h4>Controles Preventivos</h4>
                    <ol>
                      <li :class="{ fontRed: control.critico }" v-for="(control, i) in getControlesPreventivos(scope.row)" v-bind:key="i">
                        {{ control.nombre }}
                      </li>
                    </ol>
                  </el-col>
                  <el-col :span="8">
                    <h4>Controles Mitigadores</h4>
                    <ol>
                      <li :class="{ fontRed: control.critico }" v-for="(control, i) in getControlesMitigadores(scope.row)" v-bind:key="i">
                        {{ control.nombre }}
                      </li>
                    </ol>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="190" align="center">
            <template slot-scope="scope">
              <el-button v-if="riesgos.length === 0" style="margin-bottom: 8px;" size="small" plain type="primary"
                @click="openCopyRisk(scope.row)" icon="el-icon-refresh">
                Copiar en otra tarea</el-button>
              <el-button size="small" plain type="danger" @click="deleteRisk(scope.row)" icon="el-icon-delete" />
              <el-button v-if="scope.row.custom" size="small" plain type="info" @click="openEditRisk(scope.row)"
                icon="el-icon-edit" />
            </template>
          </el-table-column>
          <el-table-column prop="nombre" label="Nombre" />
          <el-table-column width="100" align="center" label="Impacto">
            <template slot-scope="scope">{{getMayorImpacto(scope.row).mfl}}</template>
          </el-table-column>
          <el-table-column width="100" align="center" label="MFL">
            <template slot-scope="scope">
              <el-tag class="big" v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)">{{getMayorImpacto(scope.row).mfl}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="FS">
            <template slot-scope="scope">{{getMayorImpacto(scope.row).impacto && getMayorImpacto(scope.row).impacto.factor_severidad}}</template>
          </el-table-column>
          <el-table-column width="100" align="center" label="FP">
            <template slot-scope="scope">{{getMayorImpacto(scope.row).impacto && getMayorImpacto(scope.row).impacto.factor_probabilidad}}</template>
          </el-table-column>
          <el-table-column width="100" align="center" label="RRR">
            <template slot-scope="scope">
              <el-tag class="big" type="gray">{{getMayorImpacto(scope.row).rrr}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="NSR">
            <template slot-scope="scope">{{getMayorImpacto(scope.row).impacto && getMayorImpacto(scope.row).impacto.nivel_severidad}}</template>
          </el-table-column>
        </el-table>

        <InventarioBowtie :cambios="cambios" :editRisk="editRisk" :saveChange="saveChange" :action="action"
          :onAcept="addCustomRisk" :onClose="handleClose" :visibleSync="openDialogBowtie" :editable="true"
          :risk="newCustomRisk" :allStandardRisks="risks" :riskItem="riskItem"
          :closeDialogCustomRisk="closeDialogCustomRisk" />
        <br />
        <div v-if="taskName !== ''">
          <el-alert v-if="cantidadRiesgos === 0" title="Atención" type="warning"
            :description="`No hay ningún riesgo asociado a la tarea ${taskName}, para continuar debes agregar como mínimo uno.`"
            show-icon :closable="false"></el-alert>
        </div>
        <br />
        <div class="text-right">
          <el-button type="info" size="medium" @click="previousStep" class="big-submit">Regresar</el-button>
          <el-button class="big-submit" size="medium" type="primary" :loading="isLoading" @click="nextStep"
            :disabled="cantidadRiesgos === 0 || taskName === ''">Siguiente</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- Dialogs -->
    <dialogTableSecurityRisks :onCancel="handleClose" :onAcept="riskItem" :risks="estandarizedSecurityRisks"
      :visibleSync="dialogAddSecurityRisk" :title="$t('Riesgos estandarizados de Seguridad')"
      :handleSelectionChange="handleSelectionChange" />

    <dialogTableSecurityRisks :onCancel="handleClose" :onAcept="riskItem" :risks="estandarizedHealthRisks"
      :visibleSync="dialogAddHealthRisks" :title="$t('Riesgos estandarizados de Salud')"
      :handleSelectionChange="handleSelectionChange" />

    <dialogTableSecurityRisks :onCancel="handleClose" :onAcept="riskItem" :risks="estandarizedMedioambienteRisks"
      :visibleSync="dialogAddMedioambienteRisks" :title="$t('Riesgos estandarizados de Medioambiente')"
      :handleSelectionChange="handleSelectionChange" />

    <el-dialog :before-close="handleClose" title="Agregando" :visible="dialogNewCustomRisk">
      <el-form>
        <el-form-item label="Nombre">
          <el-input class="with-help-box" v-model="formCustomRisk.nombre" auto-complete="on"
            @keydown.native.enter.prevent @keyup.native.enter="addCustomRisk('formCustomRisk')" />
          <el-popover class="help-box" placement="right" title="Nombre del riesgo" width="200" trigger="hover" content="Escriba el nombre del 'Riesgo o Aspecto Ambiental' que desee agregar.
            El nombre debe ser breve, claro y preciso, de no más de una línea.">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="Tipo">
          <el-radio-group v-model="formCustomRisk.tipo" class="with-help-box">
            <el-radio-button label="Salud y Seguridad"></el-radio-button>
            <el-radio-button label="Medioambiental"></el-radio-button>
          </el-radio-group>
          <el-popover class="help-box" placement="right" title="Tipo del riesgo" width="200" trigger="hover"
            :content="$t('Seleccione el tipo del \'Riesgo o Aspecto Ambiental\' que desee agregar. Solo puedes seleccionar uno.')">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <p v-if="standard_risk_found">{{ standard_risk_message }}</p>
        <div v-if="!noStandardRiskLeft">
          <div v-for="standard_risk in standard_risks" :key="standard_risk.name">
            <label>
              <input type="radio" name="standard_risks" :value="standard_risk.id" v-model="formCustomRisk.standardRisk"
                @change="enableStandardRiskButton" />
              {{ standard_risk.name }}
            </label>
          </div>
        </div>
        <div v-if="noStandardRiskLeft">
          <ul v-for="standard_risk in standard_risks_original" :key="standard_risk.name">
            <li>{{ standard_risk.name }}</li>
          </ul>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogCustomRisk">Cancelar</el-button>
        <el-button :disabled="!standardRiskButtonEnabled" type="primary" @click="addCustomRiskSRR('formCustomRisk')"
          v-if="standard_risk_found">Agregar Riesgo Estandarizado</el-button>
        <el-button type="primary" @click="addCustomRisk('formCustomRisk')" v-if="!standard_risk_found">Agregar
        </el-button>
      </span>
    </el-dialog>

    <el-dialog :before-close="handleClose" title="Editando" :visible="dialogEditCustomRisk">
      <el-form>
        <el-form-item label="Nombre">
          <el-input v-model="formCustomRisk.nombre" class="with-help-box" auto-complete="on" />
          <el-popover class="help-box" placement="right" title="Nombre del riesgo" width="200" trigger="hover" content="Escriba el nombre del 'Riesgo o Aspecto Ambiental'.
            El nombre debe ser breve, claro y preciso, de no más de una línea.">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="Tipo">
          <el-radio-group v-model="formCustomRisk.tipo" class="with-help-box">
            <el-radio-button label="Salud y Seguridad"></el-radio-button>
            <el-radio-button label="Medioambiental"></el-radio-button>
          </el-radio-group>
          <el-popover class="help-box" placement="right" title="Tipo del riesgo" width="200" trigger="hover" content="Seleccione el tipo del 'Riesgo o Aspecto Ambiental'.
            Solo puedes seleccionar uno.">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogEditCustomRisk()">Cancelar</el-button>
        <el-button type="primary" @click="editCustomRisk('formCustomRisk')">Modificar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Atención" :visible.sync="dialogError" width="42%" :before-close="handleClose">
      <h1>Para continuar debes corregir los siguientes errores</h1>
      <br />
      <ol>
        <li v-for="(error, index) in errores" :key="index">{{ error }}</li>
      </ol>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="dialogError = false">Cerrar</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="Asignar nombre a la tarea " :visible.sync="dialogEditTarea" width="42%"
      :before-close="handleClose">
      <br />
      <span>Nombre de la tarea</span>
      <el-input size="medium" style="width: 100%; margin-top: 5px" v-model="nombre_tarea"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="danger" @click="dialogEditTarea = false">Cerrar</el-button>
        <el-button size="medium" type="primary" @click="changeTarea">Aceptar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Listado de tareas" append-to-body :visible.sync="dialogCopyRisk" width="52%" top="5%"
      :before-close="handleClose">
      <div style="padding-top: 8px">
        <div v-if="multiple === false">
          {{ `Usted en este momento se encuentra realizando la copia del siguiente riesgo` }}
          "{{ copy_risk.nombre }}", A continuación debe seleccionar la tarea en la
          cúal desea asignarlo.
        </div>
        <div v-if="multiple === true">
          Usted en este momento se encuentra realizando la copia de los siguientes riesgos y a continuación debe
          seleccionar la tarea en la cúal desea asignarlos.
          <ul>
            <li v-for="(item, index) in riesgos" :key="`riesgo_select-${index}`">{{ item.nombre }}</li>
          </ul>
        </div>
        <el-table empty-text="No se encuentran más tareas en el inventario" height="380"
          header-cell-class-name="header-cell-class-table-gray" border :data="all_tasks"
          style="width: 100%; margin-top: 30px">
          <el-table-column prop="nombre" label="Nombre"></el-table-column>
          <el-table-column align="center" label="Operaciones" width="170">
            <template slot-scope="scope">
              <el-button type="primary" @click="duplicarRiesgo(scope.row.id)" size="small">Seleccionar</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCopyRisk = false">Cancelar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImagesLoaded from "vue-images-loaded";
import uuid from "uuid/v4";

import dialogTableSecurityRisks from "@/components/dialogTableRisks.vue";
import InventarioBowtie from "@/components/DialogInventarioBowtieAnual.vue";
import StepsInventario from "@/components/StepsInventario.vue";
import { getMFL } from "@/utils/generalFunctions";

export default {
  name: "FirstStep",
  props: ["cambios"],
  data() {
    return {
      multiple: false,
      riesgos: [],
      copy_risk: {},
      all_tasks: [],
      dialogCopyRisk: false,
      dialogEditTarea: false,
      nombre_tarea: "",
      nombre_riesgo: "",
      escenario_residual: "",
      escenario_mfl: "",
      editRisk: false,
      taskName: this.$store.getters.inventario_copy.tareas[
        this.$store.getters.selectedIndexTask
      ].nombre,
      errores: [],
      dialogError: false,
      componentKey: 0,
      indexEdit: null,
      action: "",
      newCustomRisk: {
        _id: "",
        year: false,
        nombre: "",
        tipo: null,
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        escenario_residual: "",
        escenario_mfl: "",
        faena_id: "",
        medioambiental: false,
        medioambiente: {
          responsable: "",
          condicion: "",
          evento: "",
          equipo: "",
        },
        evaluadores: [],
        status: 1,
        status_step: 0,
        status_by: null,
        status_position: null,
        status_message: null,
      },
      openDialogBowtie: false,
      estandarizedSecurityRisks: [],
      estandarizedHealthRisks: [],
      estandarizedMedioambienteRisks: [],
      risksSelected: [],
      dialogAddMedioambienteRisks: false,
      dialogAddSecurityRisk: false,
      dialogAddHealthRisks: false,
      dialogNewCustomRisk: false,
      dialogEditCustomRisk: false,
      filterSelected: "*",
      customRiskId: null,
      standard_risks: [],
      standard_risks_original: [],
      standard_risk_message: "",
      standard_risk_found: false,
      standardRiskButtonEnabled: false,
      noStandardRiskLeft: false,
      srrLoading: false,
      formCustomRisk: {
        nombre: null,
        tipo: null,
        standardRisk: null,
      },
      isLoading: false,
      accidenteEnRutaMel: {},
    };
  },
  created() {
    this.$store.dispatch("setTitle", this.$t("Creando Inventario de Riesgos"));
    this.$store.dispatch(
      "setSubTitle",
      `${this.$t("Contrato")}: ${this.$store.getters.actualContract.nombre}`
    );
    this.$store.dispatch("getAllRisks");
    this.$store.dispatch("getAreasFaena");
  },
  components: {
    StepsInventario,
    dialogTableSecurityRisks,
    InventarioBowtie,
  },
  directives: {
    ImagesLoaded,
  },
  computed: {
    role() {
      return this.$store.getters.role;
    },
    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    },
    cantidadRiesgos() {
      if (
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        return this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.length;
      }
      return 0;
    },
    areas() {
      return this.$store.getters.areas;
    },
    securityRisks() {
      return this.risks.filter(
        (el) => el.impactos[0].categoria.toLowerCase() === "seguridad"
      );
    },
    healthRisks() {
      return this.risks.filter(
        (el) => el.impactos[0].categoria.toLowerCase() === "salud"
      );
    },
    medioambienteRisks() {
      return this.risks.filter(
        (el) =>
          el.impactos[0].categoria.toLowerCase() === "medioambiente" ||
          el.impactos[0].categoria.toLowerCase() === "medioambiental"
      );
    },
    task() {
      return (
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].id ||
        this.$store.getters.inventario_copy.tareas[
        this.$store.getters.selectedIndexTask
        ] ||
        {}
      );
    },
    taskId() {
      return this.task._id;
    },
    contract() {
      return this.$store.getters.actualContract;
    },
    contractId() {
      return this.contract._id;
    },
    ...mapGetters({
      risks: "allRisks",
      isLoggedIn: "isLoggedIn",
    }),
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    openCopyRiskList() {
      this.riesgos.forEach(r => {
        if (r.custom === true) {
          r._id = uuid();
          r.status = 0;
          r.status_step = 0;
          r.status_by = null;
          r.status_position = null;
          r.status_message = null;
          r.status_step_approve = [];
          r.status_history = null;
          r.status_updated_at = null;
        }
      });
      this.all_tasks = [];
      this.$store.getters.inventario_copy.tareas.forEach((t) => {
        this.all_tasks.push({ id: t._id || t.id, nombre: t.nombre });
      });
      this.all_tasks.splice(this.$store.getters.selectedIndexTask, 1);
      this.multiple = true;
      this.dialogCopyRisk = true;
    },
    handleSelectionChangeTareas(val) {
      this.riesgos = JSON.parse(JSON.stringify(val));
    },
    openCopyRisk(risk) {
      const riesgo = JSON.parse(JSON.stringify(risk));
      if (riesgo.custom === true) {
        riesgo._id = uuid();
        riesgo.status = 0;
        riesgo.status_step = 0;
        riesgo.status_by = null;
        riesgo.status_position = null;
        riesgo.status_message = null;
        riesgo.status_step_approve = [];
        riesgo.status_history = null;
        riesgo.status_updated_at = null;
      }
      this.copy_risk = riesgo;
      this.all_tasks = [];
      this.$store.getters.inventario_copy.tareas.forEach((t) => {
        this.all_tasks.push({ id: t._id || t.id, nombre: t.nombre });
      });
      this.all_tasks.splice(this.$store.getters.selectedIndexTask, 1);
      this.dialogCopyRisk = true;
    },
    duplicarRiesgo(tarea_id) {
      let nombre_tarea = "";
      if (this.multiple === false) {
        const nombre_riesgo = this.copy_risk.nombre;
        this.$confirm(
          `Estás a punto de duplicar el riesgo "${nombre_riesgo}". Continuar?`,
          "Advertencia",
          {
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        ).then(() => {
          this.$store.getters.inventario_copy.tareas.forEach((t, index) => {
            if (t.id === tarea_id || t._id === tarea_id) {
              nombre_tarea = t.nombre;
              this.$store.dispatch("duplicateRiskAnual", {
                risk: this.copy_risk,
                index,
              });
            }
          });
          this.handleClose();
          this.copy_risk = {};
          this.all_tasks = [];
          this.riesgos = [];
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: `El riesgo '${nombre_riesgo}' se ha copiado con exito en la tarea '${nombre_tarea}'.`,
            type: "success",
          });
          this.toggleSelection();
        });
      }
      if (this.multiple === true) {
        this.$confirm(
          `Estás a punto de duplicar los riesgos seleccionados. Continuar?`,
          "Advertencia",
          {
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        ).then(() => {
          this.$store.getters.inventario_copy.tareas.forEach((t, index) => {
            if (t.id === tarea_id || t._id === tarea_id) {
              nombre_tarea = t.nombre;
              this.riesgos.forEach(r => {
                this.$store.dispatch("duplicateRiskAnual", {
                  risk: r,
                  index,
                });
              });
            }
          });
          this.handleClose();
          this.copy_risk = {};
          this.all_tasks = [];
          this.riesgos = [];
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: `Los riesgos se han copiado con exito en la tarea '${nombre_tarea}'.`,
            type: "success",
          });
          this.toggleSelection();
        });
      }
    },
    changeTarea() {
      this.$store.dispatch("addChange", {
        num: this.$store.getters.cambios.length + 1,
        id: this.$store.getters.cambios.length + 1,
        tarea: this.taskName,
        riesgo: "---",
        descripcion: `Se cambia el nombre de la tarea ${this.taskName === "" ? "---" : this.taskName
          } / Nuevo valor --> ${this.nombre_tarea}.`,
        date: new Date(),
      });
      this.taskName = this.nombre_tarea;
      this.dialogEditTarea = false;
    },
    openDialogTarea() {
      this.dialogEditTarea = true;
      this.nombre_tarea = this.taskName;
    },
    assignTaskName() {
      this.$store.getters.cambios.forEach((c) => {
        if (
          c["id"] ===
          this.$store.getters.inventario_copy.tareas[
            this.$store.getters.selectedIndexTask
          ]._id
        ) {
          c["tarea"] = this.taskName;
        }
      });
      this.$store.dispatch("editTask", {
        anual: true,
        taskId:
          this.$store.getters.inventario_copy.tareas[
            this.$store.getters.selectedIndexTask
          ].id ||
          this.$store.getters.inventario_copy.tareas[
            this.$store.getters.selectedIndexTask
          ]._id,
        nombre: this.taskName,
      });
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTablaPloma ";
      if (columnIndex === 1) {
        if (row.custom === true) {
          classes += "colorCustom";
        } else if (row.impactos[0].categoria === "Seguridad" && !row.custom) {
          classes += "colorSeguridad";
        } else if (row.impactos[0].categoria === "Salud" && !row.custom) {
          classes += "colorSalud";
        } else if (
          row.impactos[0].categoria === "Medioambiente" &&
          !row.custom
        ) {
          classes += "colorMedioambiente";
        }
      }
      return classes;
    },
    saveChange(risk) {
      if (this.isRiskReady(risk).status === true) {
        if (this.nombre_riesgo !== this.newCustomRisk.nombre) {
          this.$store.dispatch("addChange", {
            num: this.$store.getters.cambios.length + 1,
            id: this.$store.getters.cambios.length + 1,
            tarea: this.taskName,
            riesgo: this.newCustomRisk.nombre,
            descripcion: `Se cambia el nombre del riesgo ${this.nombre_riesgo} / Nuevo Valor -> (${this.newCustomRisk.nombre}).`,
            date: new Date(),
          });
        }
        if (this.escenario_mfl !== this.newCustomRisk.escenario_mfl) {
          this.$store.dispatch("addChange", {
            num: this.$store.getters.cambios.length + 1,
            id: this.$store.getters.cambios.length + 1,
            tarea: this.taskName,
            riesgo: this.newCustomRisk.nombre,
            descripcion: `Se cambia escenario MFL / Nuevo Valor -> (${this.newCustomRisk.escenario_mfl}).`,
            date: new Date(),
          });
        }
        if (this.escenario_residual !== this.newCustomRisk.escenario_residual) {
          this.$store.dispatch("addChange", {
            num: this.$store.getters.cambios.length + 1,
            id: this.$store.getters.cambios.length + 1,
            tarea: this.taskName,
            riesgo: this.newCustomRisk.nombre,
            descripcion: `Se cambia escenario residual / Nuevo Valor -> (${this.newCustomRisk.escenario_residual}).`,
            date: new Date(),
          });
        }
        this.$store.dispatch("editCustomRiskYear", risk);
        this.$notify.info({
          duration: 3000,
          title: "Atención",
          message: `Riesgo ${risk.nombre} modificado exitosamente`,
        });
        // this.resetStatusRisk();
        this.forceRerender();
        this.handleClose();
      } else {
        let textError = "";
        for (
          let index = 0;
          index < this.isRiskReady(this.newCustomRisk).errors.length;
          index++
        ) {
          textError = `${textError}<li class="listaError">${this.isRiskReady(this.newCustomRisk).errors[index]
            }</li>`;
        }
        this.$alert(`<ol class="listaError">${textError}</ol>`, "Atención", {
          type: "error",
          dangerouslyUseHTMLString: true,
        });
      }
    },
    resetStatusRisk() {
      this.newCustomRisk.status = 0;
      this.newCustomRisk.status_step = 0;
      this.newCustomRisk.status_by = null;
      this.newCustomRisk.status_position = null;
      this.newCustomRisk.status_message = null;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    validarRiesgosSeguridad() {
      this.estandarizedSecurityRisks = JSON.parse(
        JSON.stringify(this.securityRisks)
      );
      if (
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach((element) => {
          const index = this.estandarizedSecurityRisks.findIndex(
            (x) => x._id === element._id
          );
          if (index !== -1) {
            this.estandarizedSecurityRisks.splice(index, 1);
          }
        });
      }
    },
    validarRiesgosSalud() {
      this.estandarizedHealthRisks = JSON.parse(
        JSON.stringify(this.healthRisks)
      );
      if (
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach((element) => {
          const index = this.estandarizedHealthRisks.findIndex(
            (x) => x._id === element._id
          );
          if (index !== -1) {
            this.estandarizedHealthRisks.splice(index, 1);
          }
        });
      }
    },
    validarRiesgosMedioambiente() {
      this.estandarizedMedioambienteRisks = JSON.parse(
        JSON.stringify(this.medioambienteRisks)
      );
      if (
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach((element) => {
          const index = this.estandarizedMedioambienteRisks.findIndex(
            (x) => x._id === element._id
          );
          if (index !== -1) {
            this.estandarizedMedioambienteRisks.splice(index, 1);
          }
        });
      }
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map((key) => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
      }));
      return controles;
    },
    handleSelectionChange(risks) {
      this.risksSelected = risks;
    },
    openDialogAddSecurityRisk() {
      this.dialogAddSecurityRisk = true;
      this.validarRiesgosSeguridad();
    },
    openDialogAddCustomRisk() {
      this.action = "add";
      this.openDialogBowtie = true;
      this.setIdRisk();
    },
    openDialogAddHealthRisks() {
      this.dialogAddHealthRisks = true;
      this.validarRiesgosSalud();
    },
    openDialogAddMediambienteRisks() {
      this.dialogAddMedioambienteRisks = true;
      this.validarRiesgosMedioambiente();
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    enableStandardRiskButton() {
      this.standardRiskButtonEnabled = true;
    },
    handleClose() {
      this.dialogCopyRisk = false;
      this.dialogEditTarea = false;
      this.dialogError = false;
      this.openDialogBowtie = false;
      this.dialogNewCustomRisk = false;
      this.dialogEditCustomRisk = false;
      this.dialogAddSecurityRisk = false;
      this.risksSelected = [];
      this.dialogAddHealthRisks = false;
      this.dialogAddMedioambienteRisks = false;
      this.newCustomRisk = {
        _id: "",
        nombre: "",
        tipo: "",
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        faena_id: "",
        medioambiental: false,
        medioambiente: {
          responsable: "",
          condicion: "",
          evento: "",
          equipo: "",
        },
        evaluadores: [],
        causas: [],
        status: 0,
        status_step: 0,
        status_by: null,
        status_position: null,
        status_message: null,
      };
      this.editRisk = false;
    },
    openEditRisk(risk) {
      this.nombre_riesgo = risk.nombre;
      this.escenario_residual = risk.escenario_residual;
      this.escenario_mfl = risk.escenario_mfl;
      this.newCustomRisk = JSON.parse(JSON.stringify(risk));
      if (!this.newCustomRisk.medioambiente) {
        this.newCustomRisk.medioambiente = {};
        this.newCustomRisk.medioambiente.responsable = "";
        this.newCustomRisk.medioambiente.condicion = "";
        this.newCustomRisk.medioambiente.evento = "";
        this.newCustomRisk.medioambiente.equipo = "";
      }
      this.action = "edit";
      this.openDialogBowtie = true;
      this.editRisk = true;
    },
    filter(option) {
      this.filterSelected = option;
      this.$refs.cpt2.filter("byArea");
    },
    riskItem() {
      this.risksSelected.forEach((element) => {
        element["anual"] = true;
        this.$store.dispatch("addChange", {
          num: this.$store.getters.cambios.length + 1,
          id: this.$store.getters.cambios.length + 1,
          tarea: this.taskName,
          riesgo: element.nombre,
          descripcion: "Se crea nuevo riesgo",
          date: new Date(),
        });
        this.$store.dispatch("addRisk", element);
      });
      this.$notify.info({
        duration: 3000,
        title: "Atención",
        message: "Riesgos estandarizados se agregaron exitosamente",
      });
      this.handleClose();
    },

    addCustomRisk() {
      const findRisk = this.$store.getters.inventario_copy.tareas[
        this.$store.getters.selectedIndexTask
      ].riesgos
        ? this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.find(
          (risk) =>
            risk.nombre.toLowerCase() ===
            this.newCustomRisk.nombre.toLowerCase()
        )
        : false;
      if (findRisk) {
        this.$message({
          message:
            "Advertencia, El riesgo que estás ingresando ya se encuentra registrado en el inventario, por favor verifíquelo.",
          type: "warning",
        });
      } else if (this.isRiskReady(this.newCustomRisk).status === true) {
        this.newCustomRisk["anual"] = true;
        this.$store.dispatch("addRisk", this.newCustomRisk);
        this.$store.dispatch("addChange", {
          num: this.$store.getters.cambios.length + 1,
          id: this.$store.getters.cambios.length + 1,
          tarea: this.taskName,
          riesgo: this.newCustomRisk.nombre,
          descripcion: "Se crea nuevo riesgo",
          date: new Date(),
        });
        this.$notify.info({
          duration: 3000,
          title: "Atención",
          message: `Riesgo ${this.newCustomRisk.nombre} fue agregado exitosamente`,
        });
        this.handleClose();
      } else {
        this.errores = [];
        for (
          let index = 0;
          index < this.isRiskReady(this.newCustomRisk).errors.length;
          index++
        ) {
          this.errores.push(this.isRiskReady(this.newCustomRisk).errors[index]);
        }
        this.dialogError = true;
      }
    },
    isRiskReady(risk) {
      const errors = [];
      if (risk && risk.custom === true) {
        // Verifica que exista nombre en el riesgo
        if (risk.nombre === "") {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene un nombre asociado"
            )}`
          );
        }
        // Verifica que exista nombre en el riesgo
        if (risk.tipo === null) {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene un tipo asociado"
            )}`
          );
        }
        // Verifica que existan causas en el riesgo
        if (!risk.causas || risk.causas.length === 0) {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene causas asociadas"
            )}`
          );
        }
        // Verificar que existan impactos en el riesgo
        if (!risk.impactos || risk.impactos.length === 0) {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene impactos asociados"
            )}`
          );
        }
        // Verifica que todas las causas tengan controles preventivos
        if (risk.causas.length > 0) {
          risk.causas.forEach((causa) => {
            if (
              !causa.controles_preventivos ||
              causa.controles_preventivos.length === 0
            ) {
              errors.push(
                `Riesgo "${risk.nombre}", ${this.$t("Causa")} '${causa.nombre
                }' ${this.$t("no tiene controles preventivos asociados")}`
              );
            }
          });
        } else {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene controles preventivos asociados"
            )}`
          );
        }

        risk.impactos.forEach((impacto) => {
          if (
            !impacto.controles_mitigadores ||
            impacto.controles_mitigadores.length === 0
          ) {
            errors.push(
              `Riesgo "${risk.nombre}", ${this.$t("Impacto")} '${impacto.categoria
              }' ${this.$t("no tiene controles mitigadores asociados")}`
            );
          }
        });

        // Valida Equipo Evaluador
        /* if (!risk.evaluadores || risk.evaluadores.length === 0) {
          errors.push(
            `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
              'no tiene ningún evaluador',
            )}`,
          );
        } */
        // Valida escenarios escenario_residual: '', escenario_mfl: '',
        /* if (!risk.escenario_residual || risk.escenario_residual === "") {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene escenario residual"
            )}`
          );
        } */

        /* if (!risk.escenario_mfl || risk.escenario_mfl === "") {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene escenario MFL"
            )}`
          );
        } */

        /* if (risk.tipo === 'medioambiente') {
          if (!risk.medioambiente.responsable) {
            errors.push(
              `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
                'no tiene responsable',
              )}`,
            );
          }

          if (!risk.medioambiente.evento) {
            errors.push(
              `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
                'no tiene evento',
              )}`,
            );
          }

          if (!risk.medioambiente.condicion) {
            errors.push(
              `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
                'no tiene condición',
              )}`,
            );
          }

          if (!risk.medioambiente.equipo) {
            errors.push(
              `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
                'no tiene equipo crítico',
              )}`,
            );
          }
        } */

        if (errors.length > 0) {
          return { status: false, errors };
        }
        return { status: true, errors };
      }
      return { status: true, errors };
    },
    setIdRisk() {
      this.newCustomRisk._id = uuid();
    },
    deleteRisk(risk) {
      this.$confirm(
        `Estás a punto de eliminar el riesgo "${risk.nombre}". Continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("addChange", {
            num: this.$store.getters.cambios.length + 1,
            id: this.$store.getters.cambios.length + 1,
            tarea: this.taskName,
            riesgo: risk.nombre,
            descripcion: "Se elimina riesgo",
            date: new Date(),
          });
          risk["anual"] = true;
          this.$store.dispatch("deleteCustomRisk", risk);
          this.$notify.info({
            duration: 3000,
            title: "Atención",
            message: `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "eliminado exitosamente"
            )}`,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Acción cancelada",
          });
        });
    },
    closeDialogCustomRisk() {
      this.formCustomRisk.nombre = "";
      this.formCustomRisk.tipo = null;
      this.dialogNewCustomRisk = false;
      this.standard_risks = [];
      this.standard_risks_original = [];
      this.standard_risk_found = false;
      this.standard_risk_message = "";
      this.noStandardRiskLeft = false;
      this.srrLoading = false;
      this.formCustomRisk.standardRisk = null;
      this.standardRiskButtonEnabled = false;
    },
    closeDialogEditCustomRisk() {
      this.formCustomRisk.nombre = "";
      this.formCustomRisk.tipo = null;
      this.dialogEditCustomRisk = false;
    },
    previousStep() {
      if (this.taskName && this.taskName !== "") {
        this.assignTaskName();
        this.$store.dispatch("setStep", 1);
      }
      if ((!this.taskName || this.taskName === "") && this.cantidadRiesgos > 0) {
        this.$message({
          type: "warning",
          message: "Se debe asignar el nombre de la tarea para regresar",
        });
      }
      if ((!this.taskName && this.cantidadRiesgos === 0) || (this.taskName === "" && this.cantidadRiesgos === 0)) {
        var removeIndex = this.$store.getters.cambios
          .map(function (item) {
            return item.id;
          })
          .indexOf(
            this.$store.getters.inventario_copy.tareas[
              this.$store.getters.selectedIndexTask
            ]._id
          );
        this.$store.dispatch("deleteCambio", removeIndex);
        this.$store
          .dispatch(
            "deleteTask",
            this.$store.getters.inventario_copy.tareas[
            this.$store.getters.selectedIndexTask
            ]
          )
          .then(() => {
            this.$store.dispatch("setStep", 1);
          });
        this.$store.dispatch("setStep", 1);
      }
    },
    nextStep() {
      if (this.taskName && this.taskName !== "") {
        this.assignTaskName();
        this.errores = [];
        let errors = [];
        this.$store.getters.inventario_copy.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach((risk) => {
          errors = errors.concat(this.isRiskReady(risk).errors);
        });
        this.isLoading = false;
        if (errors.length > 0) {
          this.errores = errors;
          this.dialogError = true;
          return;
        }
        this.$store.dispatch("setStep", 3);
      } else {
        this.$message({
          type: "warning",
          message: "Se debe asignar el nombre de la tarea para continuar",
        });
      }
    },
  },
};
</script>

<style>
.countRisk {
  font-size: 31px;
  color: rgb(230, 84, 0);
  font-weight: bold;
}

.nameTask {
  font-size: 21px;
}

.tableRisks {
  margin-top: 10px;
}

.cuadrado {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}

.listaError {
  margin-left: 13px;
  padding: 0px;
  margin-bottom: 5px;
}

.alertError {
  width: 70%;
}

.fontRed {
  color: red;
}

.messageTask {
  font-size: 13px !important;
}

.title-task {
  margin-bottom: 0px !important;
}

.intermitente {
  padding: 15px 15px;
  box-shadow: 0px 0px 20px;
  color: rgb(230, 84, 0);
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {

  0%,
  100% {
    box-shadow: 0px 0px 20px;
  }

  50% {
    box-shadow: 0px 0px 0px;
  }
}
</style>
